"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelSVGDraw = exports.LABEL_SIZE = exports.Style = void 0;
const model_1 = require("../../model");
const fetchable_1 = require("../../rest/fetchable");
const mithril_1 = require("../mithril");
const theme_1 = require("../theme");
const util_draw_svg_1 = require("./util.draw.svg");
function getComputedTextLengthSafe(textEl) {
    try {
        return textEl.getComputedTextLength();
    }
    catch (_e) {
        return 0;
    }
}
const LABEL_ACCEPT_AND_DELETE_RADIUS = 8;
const DEFAULT_CHAR_WIDTH = 6;
const ELEMENT_NODE = 1;
// Character width mapping for Roboto Condensed at 14px font size
const ROBOTO_CONDENSED_CHAR_WIDTHS = {
    0: 7.8,
    1: 7.8,
    2: 7.8,
    3: 7.8,
    4: 7.8,
    5: 7.8,
    6: 7.8,
    7: 7.8,
    8: 7.8,
    9: 7.8,
    A: 8.1,
    B: 7.9,
    C: 8.0,
    D: 8.3,
    E: 7.2,
    F: 6.8,
    G: 8.5,
    H: 8.2,
    I: 3.2,
    J: 5.8,
    K: 7.7,
    L: 6.5,
    M: 9.8,
    N: 8.2,
    O: 8.7,
    P: 7.5,
    Q: 8.7,
    R: 7.8,
    S: 7.5,
    T: 7.0,
    U: 8.0,
    V: 7.8,
    W: 11.2,
    X: 7.5,
    Y: 7.3,
    Z: 7.2,
    a: 6.8,
    b: 7.2,
    c: 6.5,
    d: 7.2,
    e: 6.8,
    f: 4.0,
    g: 7.2,
    h: 7.0,
    i: 3.0,
    j: 3.0,
    k: 6.3,
    l: 3.0,
    m: 10.5,
    n: 7.0,
    o: 7.0,
    p: 7.2,
    q: 7.2,
    r: 4.3,
    s: 6.2,
    t: 4.0,
    u: 7.0,
    v: 6.2,
    w: 9.0,
    x: 6.0,
    y: 6.2,
    z: 6.0,
    ' ': 3.5,
    '.': 3.0,
    ',': 3.0,
    '!': 3.5,
    '?': 6.5,
    ':': 3.0,
    ';': 3.0,
    "'": 2.3,
    '"': 4.5,
    '-': 4.2,
    _: 5.5,
    '(': 4.2,
    ')': 4.2,
    '[': 3.8,
    ']': 3.8,
    '{': 4.5,
    '}': 4.5,
    '/': 5.2,
    '\\': 5.2,
    '|': 3.2,
    '@': 11.5,
    '#': 8.0,
    $: 7.8,
    '%': 11.0,
    '^': 6.5,
    '&': 8.5,
    '*': 5.5,
    '+': 7.3,
    '=': 7.3,
    '<': 7.3,
    '>': 7.3,
    '~': 7.8,
    '`': 4.0,
    '…': 7.0,
};
function getCharWidth(char) {
    return ROBOTO_CONDENSED_CHAR_WIDTHS[char] || 6.5; // Default width for unmapped characters
}
/**
 * Calculates the total width of text using Roboto Condensed character widths
 */
function calculateTextWidth(text, fontSize = 14) {
    const scale = fontSize / 14;
    let width = 0;
    for (let i = 0; i < text.length; i++) {
        const char = text.charAt(i);
        width += getCharWidth(char) * scale;
    }
    return width;
}
/**
 * Truncates text for PDF export using Roboto Condensed character widths
 */
function truncateTextForPDF(text, maxWidth, fontSize = 14) {
    const ellipsisWidth = calculateTextWidth('…', fontSize);
    const availableWidth = maxWidth - ellipsisWidth;
    if (calculateTextWidth(text, fontSize) <= maxWidth) {
        return text;
    }
    let truncatedText = '';
    let currentWidth = 0;
    for (let i = 0; i < text.length; i++) {
        const char = text.charAt(i); // Use charAt instead of bracket notation
        const charWidth = getCharWidth(char) * (fontSize / 14);
        if (currentWidth + charWidth > availableWidth) {
            break;
        }
        truncatedText += char;
        currentWidth += charWidth;
    }
    return truncatedText + '…';
}
/** Line length to verify that it is not too long, in characters */
const ELLIPSIS_LINE_LENGTH = 25;
/** Length of a line that will have to be ...'d  */
const ELLIPSIS_LINE_MAX_LENGTH = 35;
exports.Style = {
    [theme_1.ClassNames.label.text]: {
        'font-size': theme_1.StyleConfig.FONT_SIZE + 'px',
        'user-select': 'none',
        'pointer-events': 'none',
    },
    [theme_1.ClassNames.label.rect.container]: {
        fill: theme_1.StyleConfig.LABEL.FILL,
        stroke: 'none',
        'stroke-width': 0,
    },
    [theme_1.ClassNames.label.rect.isHighlighted]: {
        fill: theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED,
    },
};
exports.LABEL_SIZE = {
    height: 5,
    width: 210,
};
class LabelSVGDraw {
    static view(label, options) {
        var _a;
        const labelChildren = [];
        const parent = label.parent;
        let nodeId = label.id;
        let labelHeight = LabelSVGDraw.height(1);
        let isParentSelected = false;
        let isDeleteShown = false;
        let isAcceptShown = false;
        let spanColors = null;
        const backgroundRectAttrs = {};
        // Label text for each class of parent
        if (parent != null &&
            (model_1.CollectionModelDrawableMarker.isMarker(parent) || model_1.CollectionModelDrawableMarkerOffset.isBaseOffset(parent))) {
            const text = options.draw.getLabelText(parent.id, options);
            spanColors = options.useColorCoding ? options.draw.getSpanColors(parent.id) : null;
            labelHeight = LabelSVGDraw.height(text.length);
            labelChildren.push(LabelSVGDraw.textLines(label, options, text));
            nodeId = parent.id;
            // If the label is for a base or base offset insight marker, set the text accordingly.
            if (parent instanceof model_1.CollectionModelDrawableMarker) {
                // if the detection class is zero offset, show the base selection text
                // if the detection class is an offset class other than zero_offset, show the base offset selection text
                // if its neither then leave it as null
                const baseSelectionText = ((_a = parent.insight) === null || _a === void 0 ? void 0 : _a.detection_class) === model_1.InsightMarkerDetectionClass.ZeroOffset
                    ? 'Select to Set Base'
                    : parent.isInsightBaseOffsetDetectionClass
                        ? 'Select to Set Base Offset'
                        : null;
                if (baseSelectionText && !parent.collectionHasBase) {
                    labelChildren.push(LabelSVGDraw.textLines(label, options, [baseSelectionText]));
                }
            }
            isDeleteShown =
                options.isInteractive && options.isEditable && parent.isDeletable && options.draw.state.tool == null;
            isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && label.isApprovableInsightDrawable();
        }
        else if (parent != null && model_1.CollectionModelDrawableLine.isLine(parent)) {
            nodeId = parent.id;
            const text = options.draw.getLabelText(parent.id, options);
            labelHeight = LabelSVGDraw.height(text.length);
            const selectedId = options.draw.state.selectedId;
            isParentSelected = selectedId === nodeId || selectedId === parent.start.id || selectedId === parent.end.id;
            labelChildren.push(LabelSVGDraw.textLines(label, options, text));
            isDeleteShown =
                options.isInteractive && options.isEditable && parent.isDeletable && options.draw.state.tool == null;
            isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && label.isInsightMeasurement;
        }
        else if (parent != null && parent instanceof model_1.CollectionModelDrawableVerticalSeparation) {
            backgroundRectAttrs.stroke = parent.clearanceThresholdInMeters ? (parent.isInClearance ? 'lime' : 'red') : 'none';
            backgroundRectAttrs['stroke-width'] = theme_1.StyleConfig.STROKE_WIDTH * options.scale;
            labelChildren.push(LabelSVGDraw.textLines(label, options, label.getDisplayText(options)));
        }
        else {
            labelChildren.push(LabelSVGDraw.textLines(label, options, label.text));
        }
        const isSelected = options.draw.state.selectedId === nodeId || isParentSelected;
        const isHighlighted = options.draw.state.hoverId === nodeId;
        if (isDeleteShown && (isSelected || isHighlighted)) {
            labelChildren.push(LabelSVGDraw.deleteButton(options));
        }
        if (isAcceptShown && (isSelected || isHighlighted)) {
            labelChildren.push(LabelSVGDraw.acceptButton(options));
        }
        const classNames = [theme_1.ClassNames.label.container, isSelected ? theme_1.ClassNames.isSelected : null].join(' ');
        const rectClassNames = [
            theme_1.ClassNames.label.rect.container,
            isSelected ? theme_1.ClassNames.label.rect.isSelected : null,
            isHighlighted ? theme_1.ClassNames.label.rect.isHighlighted : null,
            options.isInteractive ? theme_1.ClassNames.isMoveable : null,
        ].join(' ');
        var fill = theme_1.StyleConfig.LABEL.FILL;
        if (options.isInsightMarkersVisible && label.isInsightMeasurement) {
            fill = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
        }
        else if (isHighlighted) {
            fill = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
        }
        else if (isSelected) {
            fill = theme_1.StyleConfig.LABEL.FILL_SELECTED;
        }
        if (spanColors) {
            labelChildren.push(LabelSVGDraw.rectSpansColors(spanColors, labelHeight, isHighlighted, options));
        }
        const width = options.scale * exports.LABEL_SIZE.width;
        const height = options.scale * labelHeight;
        const backgroundRect = (0, mithril_1.m)('rect', Object.assign({ className: rectClassNames, x: '0', y: '0', width,
            height,
            fill, 'fill-opacity': isHighlighted ? 0.9 : 0.75, 'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL, 'c-Draw-draggable': 'true' }, backgroundRectAttrs));
        const labelBox = (0, mithril_1.m)('g', {
            transform: `translate(${label.x}, ${label.y})`,
        }, [[backgroundRect, ...labelChildren]]);
        return (0, mithril_1.m)('g', {
            // key: currentState.id,
            className: classNames,
            'c-Draw-node-id': nodeId,
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL,
        }, [labelBox, ...LabelSVGDraw.DrawConnectingLineToParent(label, parent, options)]);
    }
    static DrawConnectingLineToParent(label, parent, options) {
        try {
            const parentConnectionPoint = parent.getLabelConnectionPoint(options);
            // If the label is on the left, set the label connection point to be the middle of the right side of the label.
            // Otherwise, set it to the middle of the left side of the label.
            const labelConnectionPoint = {
                x: label.isOnLeftSide()
                    ? label.x + options.scale * LabelSVGDraw.Size.width // Right
                    : label.x + 5, // Left
                y: label.y + (options.scale * LabelSVGDraw.height(label.text.length)) / 2,
            };
            // Draw the line connecting the label to the parent.
            return [
                util_draw_svg_1.SVGUtil.DrawLineMain(parentConnectionPoint, labelConnectionPoint, options.scale),
                util_draw_svg_1.SVGUtil.DrawLineSecondary(parentConnectionPoint, labelConnectionPoint, options.scale, parent.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY),
            ];
        }
        catch (error) {
            if (error instanceof fetchable_1.IkeFetchableRaceError) {
                options.draw.log.warn({ error }, 'Caught IkeFetchableRaceError');
                return [];
            }
            throw error;
        }
    }
    static rectSpansColors(spanColors, labelHeight, isHighlighted, options) {
        const width = options.scale * exports.LABEL_SIZE.width;
        const height = options.scale * labelHeight;
        let colorRects = [];
        spanColors.forEach((color, index) => {
            const colorRect = (0, mithril_1.m)('rect', {
                x: width * 0.015 * index,
                y: '0',
                width: width * 0.015,
                height,
                fill: color,
                'fill-opacity': isHighlighted ? 1 : 0.85,
            });
            colorRects.push(colorRect);
        });
        return colorRects;
    }
    static height(lineCount) {
        return exports.LABEL_SIZE.height + (theme_1.StyleConfig.FONT_SIZE + 0.25 * theme_1.StyleConfig.FONT_SIZE) * (lineCount || 1);
    }
    static textLines(node, options, lines) {
        var _a;
        let longestLine = 0;
        const output = [];
        for (let i = 0; i < lines.length; i++) {
            var line = (_a = lines[i]) !== null && _a !== void 0 ? _a : '';
            var text = LabelSVGDraw.text(node, options, line, i);
            text.attrs.y = 1 + i * 1.25 + 'em';
            longestLine = Math.max(longestLine, line.length);
            output.push(text);
        }
        const displayAsInsight = options.isInsightMarkersVisible && node.isInsightMeasurement;
        const xOffset = (exports.LABEL_SIZE.width * options.scale) / 2;
        const attrs = {
            transform: `translate(${xOffset}, ${(-6 * options.scale) / 4})scale(${options.scale})`,
            fill: options.isInsightMarkersVisible && displayAsInsight ? theme_1.StyleConfig.FONT_COLOR_INSIGHT : theme_1.StyleConfig.FONT_COLOR,
        };
        if (options.isInteractive && longestLine > ELLIPSIS_LINE_LENGTH) {
            const ellipsisText = (el) => LabelSVGDraw.ellipsisText(el);
            attrs['oncreate'] = ellipsisText;
            attrs['onupdate'] = ellipsisText;
        }
        return (0, mithril_1.m)('g', attrs, output);
    }
    static text(node, options, line, offset) {
        let outputLine = line;
        // Truncate text only for PDF, for browser is done differently
        if (options.isInteractive === false) {
            const maxWidth = exports.LABEL_SIZE.width * 0.95; // 95% of label width for padding
            outputLine = truncateTextForPDF(line, maxWidth, theme_1.StyleConfig.FONT_SIZE);
        }
        return (0, mithril_1.m)('text', {
            className: theme_1.ClassNames.label.text,
            style: exports.Style[theme_1.ClassNames.label.text],
            y: '1em',
            x: `0`,
            width: options.scale * exports.LABEL_SIZE.width,
            'text-anchor': 'middle',
            dy: '0.25em',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL,
            key: offset,
        }, outputLine);
    }
    static ellipsisText({ dom }) {
        const parentWidth = exports.LABEL_SIZE.width * 0.9;
        for (let i = 0; i < dom.childNodes.length; i++) {
            const textEl = dom.childNodes[i];
            if (textEl.nodeType !== ELEMENT_NODE) {
                continue;
            }
            const textNode = textEl.firstChild;
            if (textNode == null) {
                continue;
            }
            // Skip short lines
            if (textNode.textContent.length < ELLIPSIS_LINE_LENGTH) {
                continue;
            }
            // Skip text that has already been processed
            if (textNode.textContent.indexOf('…') > -1) {
                continue;
            }
            if (textNode.$lastText === textNode.textContent) {
                continue;
            }
            let computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            const addDots = computedLength > parentWidth;
            // If text lines are really long, just assume we will need to truncate it
            if (textNode.textContent.length > ELLIPSIS_LINE_MAX_LENGTH) {
                const textSizePerCharacter = computedLength / textNode.textContent.length;
                const maxNumberOfChars = Math.floor(parentWidth / textSizePerCharacter);
                textNode.textContent = textNode.textContent.slice(0, maxNumberOfChars);
            }
            while (computedLength > parentWidth) {
                textNode.textContent = textNode.textContent.slice(0, textNode.textContent.length - 2);
                computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            }
            if (addDots && textNode.textContent.indexOf('…') === -1) {
                textNode.textContent = textNode.textContent + '…';
            }
            else {
                textNode.$lastText = textNode.textContent;
            }
        }
    }
    static deleteButton(options) {
        const radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        const XSize = radius / 2;
        const y = radius * 1.25;
        const x = options.scale * exports.LABEL_SIZE.width - radius * 1.25;
        const strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        const X1 = (0, mithril_1.m)('line', {
            x1: x - XSize,
            y1: y - XSize,
            x2: x + XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none',
        });
        const X2 = (0, mithril_1.m)('line', {
            x1: x + XSize,
            y1: y - XSize,
            x2: x - XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none',
        });
        const circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.DELETE,
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.delete,
            transform: `translate(${(-8 * options.scale) / 4}, ${(5 * options.scale) / 4})`,
        }, [circle, X1, X2]);
    }
    static acceptButton(options) {
        const radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        const checkSymbolSize = radius / 2;
        const y = radius * 1.25;
        const x = radius * 1.25;
        const strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        const shortStroke = (0, mithril_1.m)('line', {
            x1: x - checkSymbolSize,
            y1: y,
            x2: x - checkSymbolSize * 0.5 + strokeWidth * 0.5,
            y2: y + checkSymbolSize * 0.75,
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none',
        });
        const longStroke = (0, mithril_1.m)('line', {
            x1: x - checkSymbolSize * 0.5,
            y1: y + checkSymbolSize * 0.75,
            x2: x + checkSymbolSize,
            y2: y - checkSymbolSize,
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none',
        });
        const circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.ACCEPT,
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.accept,
            transform: `translate(${(8 * options.scale) / 4}, ${(5 * options.scale) / 4})`,
        }, [circle, shortStroke, longStroke]);
    }
}
exports.LabelSVGDraw = LabelSVGDraw;
LabelSVGDraw.Size = exports.LABEL_SIZE;
//# sourceMappingURL=label.draw.svg.js.map